export const SCROLL_TO_CLASS = 'atRetirement/scrolling/transition/scrollToClass';

export const transitionScrolling = {
    scrollToClass: (value) => ({type: SCROLL_TO_CLASS, value: value})
}

export const setScrollToTop = value => ({type: SCROLL_TO_CLASS, value})